.custom-bubble-menu {
  background: var(--color-surface-secondary);
  border: 1px solid var(--color-stroke-default);
  border-radius: 0.4rem;
  padding: 0.4rem;
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
  z-index: 1000;
  position: fixed;
  height: min-content;
  width: max-content;
}

.custom-icon-button {
  all: unset;
  background-color: transparent;
  color: var(--color-grayscale-light-slate, #7a8296);
  padding: 0.4rem;
  border-radius: var(--spacing-radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2rem;
  width: 2rem;

  &:hover {
    cursor: pointer;
    background-color: var(--button-bgcolor-default-hover);
  }

  &:focus-visible {
    background-color: var(--button-bgcolor-default-focus);
  }

  &:active {
    background-color: var(--button-bgcolor-default-active);
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
    background-color: var(--button-bgcolor-default);
    color: var(--color-grayscale-white);
  }

  & svg {
    width: 1.2rem;
    height: 1.2rem;
    fill: var(--color-grayscale-light-slate, #7a8296);

    & path {
      fill: var(--color-grayscale-light-slate, #7a8296);
      stroke: var(--color-grayscale-light-slate, #7a8296);
    }
  }

  &.is-active {
    background-color: var(--color-surface-further);
  }
}

.drop-down-trigger {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.arrow-down-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.4rem;

  svg {
    fill: var(--color-grayscale-white);
    height: 0.4rem;
    width: 0.74rem;
  }
}
